import { render, staticRenderFns } from "./ComplaintFormModal.vue?vue&type=template&id=14cbf41e&scoped=true&"
import script from "./ComplaintFormModal.vue?vue&type=script&lang=js&"
export * from "./ComplaintFormModal.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "14cbf41e",
  null
  
)

export default component.exports